import { render, staticRenderFns } from "./top7.vue?vue&type=template&id=51b1eea2&scoped=true"
var script = {}
import style0 from "./top7.vue?vue&type=style&index=0&id=51b1eea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1eea2",
  null
  
)

export default component.exports